var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L30 14M24 26C24 28.2091 22.2091 30 20 30C17.7909 30 16 28.2091 16 26C16 23.7909 17.7909 22 20 22C22.2091 22 24 23.7909 24 26Z",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20C8 13.3726 13.3726 8 20 8C22.1857 8 24.235 8.58437 26 9.60539",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 20.0001C1.00012 11.0434 1.00012 6.56509 3.78261 3.78261C6.56509 1.00012 11.0434 1.00012 20.0001 1.00012C28.9568 1.00012 33.4352 1.00012 36.2176 3.78261C39.0001 6.56509 39.0001 11.0434 39.0001 20.0001C39.0001 28.9568 39.0001 33.4352 36.2176 36.2176C33.4352 39.0001 28.9568 39.0001 20.0001 39.0001C11.0434 39.0001 6.56509 39.0001 3.78261 36.2176C1.00012 33.4352 1.00012 28.9568 1.00012 20.0001Z",
    stroke: "#5784F7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeed);
export default __webpack_public_path__ + "static/media/IconSpeed.c1ced5f4843bddb713906f349f9690a1.svg";
export { ForwardRef as ReactComponent };